/** Session flag: painel rodando dentro do BrowserView do DeliDesk. */
export const DELIDESK_EMBED_KEY = "delivai_delidesk_embed";

export function markDelideskEmbed(): void {
  try {
    localStorage.setItem(DELIDESK_EMBED_KEY, "1");
  } catch {
    /* ignore */
  }
}

export function clearDelideskEmbed(): void {
  try {
    localStorage.removeItem(DELIDESK_EMBED_KEY);
  } catch {
    /* ignore */
  }
}

export function isDelideskEmbed(): boolean {
  try {
    if (typeof document !== "undefined" && document.documentElement.classList.contains("delidesk-embed")) {
      markDelideskEmbed();
      return true;
    }
    if (localStorage.getItem(DELIDESK_EMBED_KEY) === "1") return true;
    if (typeof window === "undefined") return false;
    const q = new URLSearchParams(window.location.search);
    if (q.get("embed") === "delidesk") {
      markDelideskEmbed();
      return true;
    }
  } catch {
    /* ignore */
  }
  return false;
}
